module.exports = __webpack_public_path__ + "static/media/mono-logo-black.d82ff2f8.png";